import React, { memo, useState, useRef } from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import Logo from "../images/logo.svg";
import personIcon from "../images/person.svg";
import EmailSchema from "./comman/validation/EmailSchema";

import {
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CircleImg from "../images/circle-pattern-1.png";
import ArrowDown from "../images/arrow-down.svg";
import VisibilityOff from "../images/eye-close.svg";
import Visibility from "../images/eye-icon.svg";
import LockIcon from "../images/lock_icon.svg";
import refrechIcon from "../images/refresh-icon.svg";
import captchaIcon from "../images/re-load.svg";
import emailIcon from "../images/email-icon.svg";
import phoneIcon from "../images/phone-icon.svg";
import backIcon from "../images/back-arrow-left.svg";
import { useEffect } from "react";
import { SIGNIN_ROUTE, SIGNUP_ROUTE } from "../constants/RoutePath";
import { useNavigate, Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { CustomMessage, deCryptFun, enCryptFun } from "./comman/CustomFunction";
import { FORGET_PASSWORD_URL } from "../constants/ApiRoute";
import { authHeader } from "./comman/MainFunction";
import API from "./comman/API";
import CustomLoader from "./comman/CustomLoader";

import Captcha from "./comman/Captcha";
import CreateNewAccountModel from "./model/CreateNewAccountModel";
import { useToast } from "./comman/CustomMessages";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const initialValues = {
  email: "",
  captcha: "",
};

const ForgotPassword = () => {
  const showToast = useToast();

  const navigate = useNavigate();
  const captchaRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [onChaptcha, setOnChaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [flag, setFlag] = useState(false);
  const validationSchema = Yup.object({
    email: EmailSchema.required("Email is required"),
    captcha: Yup.string()
      .matches(/^[^a-z]*$/, "Captcha should not contain lowercase letters")
      .required("Captcha is required"),
  });
  const {
    handleSubmit,
    handleChange,
    setValues,
    values,
    errors,
    setErrors,
    touched,
    resetForm,
    handleBlur,
    setFieldTouched,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      captchaValidation(values);
    },
  });

  const ForgotPasswordUser = async (values) => {
    setLoading(true);
    const postData = {
      email: values.email,
      linkUrl: window.location.origin + "/changepassword/",
    };

    const config = {
      method: "PUT",
      url: FORGET_PASSWORD_URL,
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
        flutterString: "",
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        // showToast("Reset password successful", "success");
        setFlag(true);
      }
      resetForm();
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
        if (captchaRef.current) {
          captchaRef.current.captchaReload();
        }
        if (v.message == "Invalid User") {
          //setValues({...values,captcha:""})
          setErrors({ ...errors, email: "Invalid user" });
          document.getElementById("user_captcha_input").value = "";
        }
      }
    } finally {
      //resetForm();
      document.getElementById("user_captcha_input").value = "";
      if (captchaRef.current) {
        captchaRef.current.captchaReload();
      }
      setLoading(false);
      setCaptchaInput("");
    }
  };
  const handleClose = () => {
    setFlag(false);
  };
  const captchaValidation = async (values) => {
    if (onChaptcha === values.captcha) {
      await ForgotPasswordUser(values);
    } else {
      // setErrors({ ...errors, captcha: "Enter valid captcha" });
      if (captchaRef.current) {
        captchaRef.current.captchaReload();
      }
      // setErrors({ ...errors, captcha: "Enter valid captcha" });
      showToast(
        "Invalid captcha validation. To ensure this is a legitmate request and not one initiated by an automated script (aka 'Bot'), please enter the text in the image exactly as it appears. If you cannot read the text in the image then you can click the refresh button to receive a new image.",
        "error"
      );
      setValues((prevValues) => ({
        ...prevValues,
        captcha: "",
      }));
      document.getElementById("user_captcha_input").value = "";
      setCaptchaInput("");
    }
  };

  const handleCaptchaChange = (newCaptcha) => {
    setOnChaptcha(newCaptcha);
  };

  const backFun = () => {
    navigate(SIGNIN_ROUTE);
  };

  const [expanded, setExpanded] = React.useState(false);

  const handleChanges = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Grid container rowSpacing={1}>
          <Grid sx={{ p: "0 !important" }} item xs={12} md={6} lg={6}>
            <Box
              sx={{
                height: {
                  xs: "auto",
                  md: "fit-content",
                  lg: "98vh",
                  xl: "90vh",
                },
                minHeight: { sm: "auto", lg: "88%" },
                padding: { xs: "40px", md: "40px 60px" },
                paddingRight: { xs: "40px", md: "68px" },
                paddingTop: "46px",
              }}
              className="welcome-box"
            >
              {/* <Box className="login-bg-color login-bg-top"></Box> */}
              <img className="logo" src={Logo} />
              <h1 className="login-title">
                Welcome to
                <br /> <span className="smart-billing">
                  Smart Billing
                </span> by <br />
                HOS Resources
              </h1>
              <p className="login-text">
                Smart Billing is the billing solution that enables HOS Resources
                to quickly collect, consolidate, and invoice billing statements
                from brokers in the field.
              </p>
              {/* <Box className="login-bg-color login-bg-bottom"></Box> */}
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChanges("panel1")}
                className="login-accord"
              >
                <AccordionSummary
                  expandIcon={<img src={ArrowDown} />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  About
                </AccordionSummary>
                <AccordionDetails>
                  HOS Resources, LLC (“HOS”) is a Lafayette, Louisiana based
                  energy consulting firm formed in 2015. HOS retains independent
                  contractor landmen to provide our clients with quality land
                  services throughout the country. These include title,
                  abstracting, curative, leasing, right-of-way acquisitions,
                  land acquisition, and any other services required to meet our
                  clients’ needs.
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChanges("panel2")}
                className="login-accord"
              >
                <AccordionSummary
                  expandIcon={<img src={ArrowDown} />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  Leadership & Experience
                </AccordionSummary>
                <AccordionDetails>
                  HOS’s founders combine for over 34 years of industry
                  experience in negotiating and acquiring oil and gas leases,
                  right-of-ways, seismic permits and options, as well as surface
                  leases throughout the country, including Louisiana,
                  Mississippi, Alabama, Texas, Utah, Minnesota, New York and
                  Illinois. They have represented oil and gas exploration
                  companies, midstream pipeline and storage companies, renewable
                  energy developers, law firms, large landowners, working
                  interest participants, private equity funds, and banks. HOS’s
                  senior landmen have over 50 years combined industry
                  experience.
                </AccordionDetails>
              </Accordion>
            </Box>
          </Grid>
          <Grid sx={{ background: "#fff" }} item xs={12} md={6} lg={6}>
            <Box
              sx={{ padding: "40px 100px 40px 76px", pt: "42px !important" }}
              className="form-box login"
            >
              <Stack
                sx={{ mb: "14px" }}
                direction="row"
                spacing={0}
                justifyContent="flex-start"
                alignItems="center"
                onClick={backFun}
              >
                <img style={{ cursor: "pointer" }} src={backIcon} />
                <p className="back-text">Back</p>
              </Stack>
              <Typography className="form-title" variant="h2">
                Forgot Password
              </Typography>
              <p style={{ marginBottom: "30px" }} className="form-text">Enter your email in the textbox below, and click the "Reset Password" button. If the provided email has an account then we will email instructions for resetting your password.</p>
              <Box component={"form"} onSubmit={handleSubmit}>
                <FormControl variant="standard">
                  <p className="label">Email</p>
                  <Input
                    name="email"
                    id="input-with-icon-adornment"
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={emailIcon} />
                      </InputAdornment>
                    }
                    placeholder="Enter your email address"
                    value={values.email}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      const newValue = e.target.value.replace(/\s/g, ""); // Remove all spaces
                      handleChange({
                        target: {
                          name: "email",
                          value: newValue,
                        },
                      });
                      if (touched.email) {
                        setFieldTouched("email", false);
                      }
                    }}
                    error={errors.email && touched.email}
                  />
                  <FormHelperText error={true}>
                    {errors.email && touched.email ? errors.email : ""}
                  </FormHelperText>
                </FormControl>

                <FormControl
                  sx={{ ".form-box.login &": { mb: "5px !important" } }}
                  variant="standard"
                >
                  <p className="label">Are you human?</p>
                  <Input
                    name="captcha"
                    id="user_captcha_input"
                    placeholder="Enter Captcha Value"
                    type="text"
                    onChange={(e) => {
                      const uppercaseValue = e.target.value.toUpperCase();
                      setCaptchaInput(e.target.value);
                      setValues((prevValues) => ({
                        ...prevValues,
                        captcha: e.target.value.toUpperCase(),
                      }));
                      handleChange({
                        ...e,
                        target: {
                          ...e.target,
                          value: uppercaseValue,
                        },
                      });
                      if (touched.captcha) {
                        setFieldTouched("captcha", false);
                      }
                    }}
                    error={errors.captcha && touched.captcha}
                    helperText={
                      errors.captcha && touched.captcha ? errors.captcha : ""
                    }
                    startAdornment={
                      <InputAdornment position="start" sx={{ mr: "10px" }}>
                        <img src={captchaIcon} />
                      </InputAdornment>
                    }
                    inputProps={{
                      style: {
                        textTransform: captchaInput ? "uppercase" : "none", // Apply uppercase only if necessary
                      },
                    }}
                  />
                  <FormHelperText error={true}>
                    {errors.captcha && touched.captcha ? errors.captcha : ""}
                  </FormHelperText>
                </FormControl>

                <Captcha
                  onChangeCaptcha={handleCaptchaChange}
                  ref={captchaRef}
                />

                <Button
                  sx={{ mt: "20px !important" }}
                  className="login-btn"
                  variant="contained"
                  size="large"
                  type="submit"
                >
                  {loading && <CustomLoader loading={loading} />}
                  Reset Password
                </Button>
                <p className="account">
                  Remember Password?{" "}
                  <Link className="link" to={SIGNIN_ROUTE} underline="none">
                    Login
                  </Link>
                </p>
              </Box>
            </Box>
          </Grid>
          {flag && (
            <CreateNewAccountModel
              open={flag}
              handleClose={handleClose}
              message={
                "Password reset request successful. Please check your email for instructions to reset your password."
              }
            />
          )}

          {/* "Password Reset Successful. Please check your email to reset password", old msg*/}

        </Grid>
      </Box>
    </>
  );
};

export default ForgotPassword;
